import React from 'react';
import { Modal } from 'react-bootstrap';
import Col from 'react-bootstrap/Col';
import Form from 'react-bootstrap/Form';
import isoDateConverter from '../isoDateConverter';

const FormRow = ({ label, controlId, children }) => (
  <Form.Group as={Col} controlId={controlId} className="d-flex flex-row bd-highlight gap-3 align-items-center">
    <Form.Label style={{ minWidth: '150px' }} className="mb-0">
      {label}
    </Form.Label>
    {children}
  </Form.Group>
);

const CustomsTechModal = ({
  show,
  onHide,
  customTechData,
  formData,
  handleInputChange,
  fieldErrors,
  errorText,
  isEditing,
  formRef,
  handleSave,
}) => {
  const inputFields = [
    { label: 'HS Code', id: 'hsCode', type: 'text', charLimit: 10 },
    { label: 'Country of Origin', id: 'origin', type: 'text', charLimit: 2 },
    { label: 'Reason', id: 'description', type: 'text', charLimit: 255 },
  ];

  const readOnlyFields = [
    { label: 'Created By:', value: customTechData?.createdBy || '' },
    {
      label: 'Created Date:',
      value: customTechData?.createdDate ? isoDateConverter(customTechData?.createdDate) : '',
    },
    { label: 'Last Updated By:', value: customTechData?.modifiedBy || '' },
    {
      label: 'Last Updated Date:',
      value: customTechData?.lastmodified ? isoDateConverter(customTechData?.lastmodified) : '',
    },
  ];

  return (
    <Modal size="lg" centered show={show} onHide={onHide} animation={false}>
      <Modal.Body>
        <h1 className="floating-box-header-general ms-0 d-inline">
          Custom Tech Rules {' - '}
          <span className="fs-6 align-middle">{isEditing ? 'Edit details' : 'New details'}</span>
        </h1>
        <Form ref={formRef} className="d-flex flex-column bd-highlight gap-3 mt-4" noValidate onSubmit={handleSave}>
          {inputFields.map((field) => (
            <FormRow key={field.id} label={field.label} controlId={field.id}>
              <input
                className={`form-control flex-grow-1 ${fieldErrors[field.id] ? 'is-invalid' : ''}`}
                type={field.type}
                id={field.id}
                value={formData[field.id]}
                onChange={(e) => handleInputChange(e, field.id)}
                maxLength={field.charLimit}
              />
            </FormRow>
          ))}

          <FormRow label="Disabled" controlId="disable">
            <input
              type="checkbox"
              id="disable"
              checked={formData.disabled}
              onChange={(e) => handleInputChange(e, 'disabled')}
            />
          </FormRow>

          {readOnlyFields.map((field) => (
            <FormRow key={field.label} label={field.label} controlId={field.label}>
              <p className="mb-0">{field.value}</p>
            </FormRow>
          ))}
        </Form>
      </Modal.Body>
      <Modal.Footer
        className="d-flex flex-row p-3 gap-3 border-top bg-light justify-content-between align-items-center"
        style={{
          borderBottomLeftRadius: '20px',
          borderBottomRightRadius: '20px',
        }}
      >
        <button
          id="cancel"
          className="blue-button-teams green-btn"
          onClick={onHide}
          style={{ display: 'flex', borderRadius: '10px' }}
        >
          Cancel
        </button>
        <div>
          <span className="red-text me-3">{errorText}</span>
          <button
            type="button"
            id="confirm"
            className="blue-button-teams"
            style={{ borderRadius: '10px' }}
            onClick={() => formRef.current.requestSubmit()}
          >
            Save
          </button>
        </div>
      </Modal.Footer>
    </Modal>
  );
};

export default CustomsTechModal;
